export var EKeyCodes;
(function (EKeyCodes) {
  EKeyCodes["Alt"] = "Alt";
  EKeyCodes["CapsLock"] = "CapsLock";
  EKeyCodes["Control"] = "Control";
  EKeyCodes["Fn"] = "Fn";
  EKeyCodes["Shift"] = "Shift";
  EKeyCodes["Enter"] = "Enter";
  EKeyCodes["Tab"] = "Tab";
  EKeyCodes["ArrowDown"] = "ArrowDown";
  EKeyCodes["ArrowLeft"] = "ArrowLeft";
  EKeyCodes["ArrowRight"] = "ArrowRight";
  EKeyCodes["ArrowUp"] = "ArrowUp";
  EKeyCodes["PageDown"] = "PageDown";
  EKeyCodes["PageUp"] = "PageUp";
  EKeyCodes["Backspace"] = "Backspace";
  EKeyCodes["Clear"] = "Clear";
  EKeyCodes["Copy"] = "Copy";
  EKeyCodes["Delete"] = "Delete";
  EKeyCodes["Escape"] = "Escape";
  EKeyCodes["Pause"] = "Pause";
  EKeyCodes["Play"] = "Play";
  EKeyCodes["ZoomIn"] = "ZoomIn";
  EKeyCodes["ZoomOut"] = "ZoomOut";
  EKeyCodes["PrintScreen"] = "PrintScreen";
})(EKeyCodes || (EKeyCodes = {}));